var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelNike14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 140,
  height: 14,
  viewBox: "0 0 140 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("text", {
  fill: "#35414C",
  fontFamily: "SourceCodePro-Bold, Source Code Pro",
  fontSize: 12,
  fontWeight: "bold"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 31,
  y: 12
}, "CHANNEL-NIKE-14")), /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FAB14D",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2 7.467c-.002.296.083.555.287.751.294.282.617.381.94.382.47 0 .937-.21 1.303-.373.616-.274 7.428-3.562 7.428-3.562.066-.036.053-.082-.029-.059L4.513 6.84a1.5 1.5 0 0 1-.43.068c-.567.004-1.071-.346-1.067-1.084.001-.288.08-.636.265-1.046-.65.85-1.275 1.903-1.281 2.69"
}))));
export default SvgChannelNike14;